import { captureException } from '@sentry/react'

// Keep this namespace stable. Introduce future changes with a new release ID.
const STORAGE_VERSION = '2026-11-preview-v1'
let storageErrorReported = false
type IntroductionKind = 'major' | 'minor'
const keyFor = (scope: string, id: string, kind: IntroductionKind) => `numeo:feature-intro:${kind}:${JSON.stringify([STORAGE_VERSION, scope, id])}`
const reportStorageError = (error: unknown) => {
    if (storageErrorReported) return
    storageErrorReported = true
    captureException(error)
}

export const hasSeenRelease = (scope: string, id: string, kind: IntroductionKind): boolean => {
    try {
        return localStorage.getItem(keyFor(scope, id, kind)) === 'seen'
    } catch (error) {
        reportStorageError(error)
        return false
    }
}
export const markReleaseSeen = (scope: string, id: string, kind: IntroductionKind): void => {
    try {
        localStorage.setItem(keyFor(scope, id, kind), 'seen')
    } catch (error) {
        reportStorageError(error)
    }
}
